

export class AllocatedPortDataOutput implements IAllocatedPortDataOutput {
    /** The auto-generated id of the tbl_device_allocated_port master */
    device_model_allocated_port_id!: number;
    /** The auto-generated id of the tbl_device_model_port_allocation master */
    device_model_port_allocation_id!: number;
    /** The model port allocation mane with 255 character */
    device_model_port_allocation_name!: string;
    /** Manage status of device model port  specification. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IAllocatedPortDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.device_model_allocated_port_id = _data["device_model_allocated_port_id"];
            this.device_model_port_allocation_id = _data["device_model_port_allocation_id"];
            this.device_model_port_allocation_name = _data["device_model_port_allocation_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AllocatedPortDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AllocatedPortDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["device_model_allocated_port_id"] = this.device_model_allocated_port_id;
        data["device_model_port_allocation_id"] = this.device_model_port_allocation_id;
        data["device_model_port_allocation_name"] = this.device_model_port_allocation_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IAllocatedPortDataOutput {
    /** The auto-generated id of the tbl_device_allocated_port master */
    device_model_allocated_port_id: number;
    /** The auto-generated id of the tbl_device_model_port_allocation master */
    device_model_port_allocation_id: number;
    /** The model port allocation mane with 255 character */
    device_model_port_allocation_name: string;
    /** Manage status of device model port  specification. 0 For De-active, 1 For Active */
    status: number;
}

